import { T } from '@territory/tokens';

/* Exact bare actions from the live Resource vault, notes and calculator. */
export function marketingResourceUtilityCss(sel: string): string {
  return `${sel} { background: none; border: none; padding: 0; cursor: pointer; font-family: ${T.mono}; font-size: 0.62rem; letter-spacing: 0.14em; text-transform: uppercase; color: var(--rv-text-muted, ${T.labelTer}); }
${sel}[data-rv-resource-utility="back"] { font-size: 0.6rem; letter-spacing: 0.12em; }
${sel}[data-rv-resource-utility="notes"] { font-size: 0.66rem; }
${sel}[data-rv-resource-utility="defaults"] { font-size: 0.58rem; letter-spacing: 0.12em; }
${sel}:focus-visible { outline: 2px solid ${T.accent}; outline-offset: 3px; border-radius: 4px; }`;
}
